import { useCallback, useEffect, useState } from 'react';

import { CONSOLE_LNB_COLLAPSED } from '../constants';

export const useLnbCollapsed = () => {
  const [collapsed, setCollapsed] = useState<boolean>(false);

  const toggleCollapsed = useCallback(() => {
    setCollapsed(prev => {
      window.localStorage.setItem(CONSOLE_LNB_COLLAPSED, !prev ? 'true' : 'false');
      return !prev;
    });
  }, []);

  useEffect(() => {
    setCollapsed(window.localStorage.getItem(CONSOLE_LNB_COLLAPSED) === 'true');
  }, []);

  return { collapsed, toggleCollapsed };
};
